<template>
<div style="position: relative;">
     <el-select multiple :disabled="disabled" collapse-tags filterable :clearable='clearable' @change="handleChange" :value="data" placeholder="请选择"
             @clear="handleChange">
            <el-option :label="item.name" :value="item.value" v-for="(item,index) in operator" :key="index"></el-option>
    
     </el-select>
     <el-checkbox  class="box" v-if="allSelect" v-model="checked" @change="handleAll">全选</el-checkbox>
</div>
 
  
</template>

<script>
    // import {getCascade} from '@/services/deviceType'
    import { findList } from "@/services/customer";

    export default {
        name: 'Operator',
        props: {
            value: {},
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            },
            allSelect:{
                type: Boolean,
                default: true   
            }
        },

        data() {
            return {data: [], operator: [],checked:false}
        },
        watch: {
            value:{
                immediate:true,
                handler(value){
                   
                    if (value) {
                           this.data=[...value];
                        } else {
                            this.data = [];
                        }

                }
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
         
            handleChange(value) {
                
              
                this.data=value;
                this.$emit("input", value);
                this.$emit("change", value);

                if(this.operator.length==this.data.length){
                    this.checked=true
                }else{
                    this.checked=false
                }
               
            },
            async loadData() {
               
                const response = await findList( { page: 1, size: 9999,});
                // console.log(response,"response")
                if (response&&response.code==0) {
                    this.operator = response.data.list.map((item, i) => {
                        return {name: item.name, value: item.id}
                    })
                }
                this.$emit("handleOperator", this.operator);
            },
            handleAll(){
                    if(this.checked){
                        let  arr =this.operator.map((item)=>{
                            return item.value
                        })

                        
                        this.$emit("change", arr);
                        this.$emit("input", arr);
                        this.data=arr;

                        
                    }else{
                        this.$emit("change", []);
                        this.$emit("input", []);
                        this.data=[];
                    }
            }

        }

    }
</script>

<style scoped>
.box{
    position: absolute;
    top: 0px;
    right: -65px;
}

</style>



// WEBPACK FOOTER //
// src/components/operation/clineList.vue